import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var InstagramColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.013 3.962c5.881 0 6.578.026 8.891.13 2.15.094 3.31.455 4.085.756 1.023.395 1.762.877 2.528 1.642.773.773 1.246 1.504 1.642 2.527.3.773.662 1.942.757 4.082.103 2.321.129 3.017.129 8.888 0 5.88-.026 6.576-.13 8.888-.094 2.149-.455 3.309-.756 4.083-.396 1.023-.877 1.762-1.642 2.527-.774.773-1.505 1.246-2.529 1.641-.773.301-1.943.662-4.084.757-2.322.103-3.018.129-8.891.129-5.882 0-6.578-.026-8.891-.13-2.15-.094-3.31-.455-4.085-.756-1.023-.395-1.762-.876-2.528-1.641-.774-.774-1.247-1.505-1.642-2.527-.301-.774-.662-1.943-.757-4.083-.103-2.321-.129-3.017-.129-8.888 0-5.88.026-6.575.13-8.888.094-2.148.455-3.309.756-4.082.395-1.023.877-1.762 1.642-2.527.774-.774 1.505-1.247 2.528-1.642.774-.301 1.944-.662 4.085-.757 2.313-.103 3.01-.129 8.89-.129Zm0-3.962c-5.976 0-6.724.026-9.072.129-2.339.103-3.947.481-5.34 1.023-1.453.567-2.682 1.315-3.904 2.544-1.23 1.22-1.977 2.45-2.545 3.894-.541 1.4-.92 3-1.023 5.338C.026 15.283 0 16.03 0 22.004s.026 6.722.129 9.069c.103 2.337.482 3.945 1.023 5.337.568 1.453 1.316 2.682 2.545 3.903a10.761 10.761 0 0 0 3.896 2.535c1.401.542 3 .92 5.34 1.023 2.347.103 3.095.129 9.071.129 5.976 0 6.725-.026 9.072-.129 2.339-.103 3.947-.481 5.34-1.023a10.76 10.76 0 0 0 3.895-2.535 10.757 10.757 0 0 0 2.537-3.894c.541-1.401.92-3 1.023-5.338.103-2.346.129-3.094.129-9.068s-.026-6.722-.129-9.068c-.103-2.338-.482-3.946-1.023-5.338-.542-1.461-1.29-2.69-2.52-3.911a10.76 10.76 0 0 0-3.895-2.536c-1.401-.541-3-.92-5.34-1.022C28.737.026 27.99 0 22.013 0Zm0 10.701c-6.243 0-11.308 5.063-11.308 11.303 0 6.24 5.065 11.303 11.307 11.303 6.243 0 11.308-5.063 11.308-11.303 0-6.24-5.065-11.303-11.308-11.303Zm0 18.635a7.334 7.334 0 0 1-7.335-7.332 7.334 7.334 0 0 1 7.334-7.332 7.334 7.334 0 0 1 7.335 7.332 7.334 7.334 0 0 1-7.335 7.332Zm11.755-16.443a2.64 2.64 0 0 0 2.64-2.639 2.64 2.64 0 1 0-2.64 2.639Z",
    svgColor: "url(#a)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.309,
    y1: 39.618,
    x2: 64.824,
    y2: -14.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FBE18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#FCBB45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#F75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#D53692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#8F39CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4FE9"
  }))));
});
InstagramColor.displayName = 'InstagramColor';
InstagramColor.defaultProps = {
  'aria-label': 'InstagramColor'
};
export default InstagramColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/InstagramColor.js
// module id = 3577
// module chunks = 11